export const FORCE_VARIANT_PARAM = 'variant';
